/*----------------------------------
- ROUTE: /tld/applications/page/:page
----------------------------------*/

/**
 * @docs docs/features/agenda
 * @adr  ADR-0055
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { definePageRoute } from '@common/router/definitions';

import { buildTldApplicationsRouteData, renderTldApplicationsRoute } from './lib/applicationsRoute';

/*----------------------------------
- PAGE
----------------------------------*/

// Path pagination (D12), never `?page=`: each page is its own URL with a self canonical, the
// news archive's model. `/page/1` answers a 301 to the base path.
export default definePageRoute({
    path: '/tld/applications/page/:page([1-9]\\d*)',
    options: { auth: false, layout: false, priority: 40 },
    data: buildTldApplicationsRouteData,
    render: renderTldApplicationsRoute,
});
